import React, { useState } from "react";
import { useGetBomListQuery } from "../store/api/bomApi"; // updated import
import { Cpu, Eye, MoreHorizontalIcon, Pencil, UserPen } from "lucide-react";
import { Button } from "../components/ui/button";
import OrderModal from "../components/modals/OrderModal";

import Datatable from "../components/Datatable";
import SearchInput from "../components/SearchInput";
import { currencyFormatter } from "../lib/utils";
import ComputeAllocationModal from "../components/modals/ComputeAllocationModal";
import { CreatableCombobox } from "../components/CreatableCombobox";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import AssignAccountModal from "../components/modals/AssignAccountModal";

const Orders = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [allocModalOpen, setAllocModalOpen] = useState(false);
  const [accountModalOpen, setAccountModalOpen] = useState(false);
  const limit = 10;

  const [account, setAccount] = useState(["1234"]);

  const { data, isLoading, error } = useGetBomListQuery({
    limit,
    offset: (page - 1) * limit,
    search,
  });

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleView = (id) => {
    setSelectedId(id);
    setViewModalOpen(true);
  };

  const handleEdit = (id) => {
    setSelectedId(id);
    setAllocModalOpen(true);
  };

  const handleAccount = (id) => {
    setSelectedId(id);
    setAccountModalOpen(true);
  };

  const columns = [
    {
      id: "id",
      label: "BOM ID",
      headClass: "min-w-[150px]",
      cellClass: "font-medium",
    },
    {
      id: "projectId",
      label: "Project ID",
      headClass: "min-w-[150px]",
    },
    {
      id: "organization",
      label: "Organization",
      render: (row) => row?.project?.customer?.organization || "",
    },
    {
      id: "orderAmount",
      label: "Order Amount",
      render: (row) =>
        currencyFormatter(
          Math.floor((row?.subsidyMaxAmount * 100) / row.subsidyPercentage)
        ),
    },
    {
      id: "subsidyPercent",
      label: "Subsidy",
      render: (row) => row?.subsidyPercentage + "%",
    },
    {
      id: "startDate",
      label: "Start Date",
      headClass: "min-w-[120px]",
    },
    {
      id: "endDate",
      label: "End Date",
      headClass: "min-w-[120px]",
    },
    {
      id: "actions",
      label: "Actions",
      headClass: "w-[80px]",
      render: (row) => (
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              aria-label="Open menu"
              size="icon-sm"
              className="px-1"
            >
              <MoreHorizontalIcon className="w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-48" align="end">
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={() => handleView(row.id)}>
                <Eye className="w-4" />
                View Order
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleEdit(row.id)}>
                <Cpu className="w-4" />
                Compute Allocation
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleAccount(row.id)}>
                <UserPen className="w-4" />
                Assign Account
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      ),
    },
  ];

  return (
    <>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-md font-bold">Orders List</h1>
          <SearchInput search={search} handleSearch={handleSearch} />
        </div>
        <Datatable
          limit={limit}
          page={page}
          setPage={setPage}
          columns={columns}
          rows={
            data?.data?.map((item) => ({
              ...item,
              projectTitle: item.project.title,
            })) || []
          }
          isLoading={isLoading}
          error={error}
          total={data?.pagination?.total || 0}
        />
      </div>
      <OrderModal
        isOpen={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
        id={selectedId}
      />
      <ComputeAllocationModal
        isOpen={allocModalOpen}
        onClose={() => setAllocModalOpen(false)}
        id={selectedId}
      />
      <AssignAccountModal
        isOpen={accountModalOpen}
        onClose={() => setAccountModalOpen(false)}
        id={selectedId}
      />
    </>
  );
};

export default Orders;
